<template>
    <!-- 订单-服务中订单 -->
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="24">
                        <span class="title">乘客电话:</span>
                        <el-input
                            v-model="search_data.consumer_phone"
                            class="handle-input mr10"
                            placeholder="请输入乘客电话"
                            maxlength="11"
                            @keyup.enter.native="serving"
                        >
                        </el-input>
                    </el-col>
                </el-row>
            </div>
            <el-button type="primary" icon="el-icon-search" @click="serving">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>
        <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="billno" label="订单编号" min-width="150px"> </el-table-column>
            <el-table-column prop="order_code" label="系统编号" min-width="110px"> </el-table-column>
            <el-table-column prop="amount" label="金额" min-width="40px"> </el-table-column>
            <el-table-column prop="city_name" label="城市" min-width="80px"> </el-table-column>
            <el-table-column prop="consumer_phone" label="乘客电话" min-width="60px"> </el-table-column>
            <el-table-column prop="start_name" label="起点"> </el-table-column>
            <el-table-column prop="end_name" label="终点"> </el-table-column>
            <el-table-column prop="order_time_stamp" label="下单时间"> </el-table-column>
            <el-table-column prop="status" label="状态" min-width="50px"> </el-table-column>
        </el-table>
        <!-- element ui 原生分页组件 -->
        <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="50"
                layout="total, sizes, prev, pager, next, jumper"
                :total="Number(result_data)"
            >
            </el-pagination>
        </div>
    </div>
</template>
<script>
var _this;
export default {
    data() {
        return {
            tableData: [],
            result_data: [],

            loading: false,

            search_data: {
                // page: 1,
                // limit: 10,
                consumer_phone: ''
            },
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            console.log(val, 'val');
            _this.search_data.limit = val;
            //初始化列表
            _this.serving();
        },
        //页码变化
        handleCurrentChange(val) {
            console.log(val, 'val页码变化');
            _this.search_data.page = val;
            console.log(_this.search_data.page, '_this.search_data.page');
            //初始化列表
            _this.serving();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        },

        // 搜索
        searchServingList() {
            _this.search_data.page = 1;
            _this.serving();
        },

        // 获取列表数据
        serving() {
            if (_this.search_data.consumer_phone == '') {
                _this.$message.error('查询条件请输入乘客电话');
                return;
            }
            _this
                .$post('/order/serving', _this.search_data)
                .then((res) => {
                    _this.tableData = res.data;
                    _this.result_data = res.count;
                })
                .catch((err) => {});
        }
    }
};
</script>
<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>